import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
// import { GetAllWeekoff } from "./../../../../../Actions/commonAction";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import get from "lodash/get";
import TextField from "@material-ui/core/TextField";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  setHelperText,
  WeekoffPlanner,
} from "../../../../../Actions/commonAction";
import TextArea from "../../../../../Component/Material-ui/TextArea";
import { isSpaceInString } from "Utils";

import { ChangeLanguage } from "../../../../../Actions/LanguageAction";

const styles = (theme) => ({
  root: {
    width: "90%",
  },
  backButton: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
});

class WeeklyNameAndDescription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notUnique: false,
      ErName: false,
      CommonError: "",
      weekoffpolicyname: "",
      description: "",
      shiftcategoryid: "",
      weekoffpolicyid: "",
      parentid: "",
      helperText: "",
    };
  }

  componentWillMount() {
    this.props.ChangeLanguage("weekoff,navigation");
  }

  componentWillUnmount() {
    this.props.StepError(1, false);
  }

  componentDidMount() {
    this.props.onRef({
      onNext: this.OnNext,
    });
    if (this.props.Language.weekoff) {
      const text = this.props.Language.weekoff.HtWeeklyoffName;
      this.props.setHelperText({ helperText: text });
    }

    this.props.StepError(1, false);
    const weekoffPlannerInfo = this.props.weekoffPlannerReducer;

    if (this.isEmpty(weekoffPlannerInfo)) {
      weekoffPlannerInfo.isdraft = true;
      this.props.WeekoffPlanner({ ...weekoffPlannerInfo });
    } else {
      const { weekoffpolicyname } = weekoffPlannerInfo;
      const { description } = weekoffPlannerInfo;
      const weekoffpolicyid = weekoffPlannerInfo.weekoffpolicyid
        ? weekoffPlannerInfo.weekoffpolicyid
        : null;
      const parentid = this.state.parentid ? weekoffPlannerInfo.parentid : 0;
      const isdraft = weekoffPlannerInfo.isdraft != false;
      this.setState({
        weekoffpolicyname,
        description,
        weekoffpolicyid,
        parentid,
        isdraft,
      });
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  OnNameChange(e) {
    this.setState({ weekoffpolicyname: e.target.value });
  }

  setTabValue(value) {
    this.setState({ value });
  }

  OnDescriptionChange(e) {
    this.setState({ description: e.target.value }, () => {
      this.UpdateweekoffPlannerReducer();
    });
  }

  checkUnique(goNext = false) {
    if (this.state.weekoffpolicyname) {
      const URL = "/subscription/uniqueweekoffpolicy";
      const data = {
        name: this.state.weekoffpolicyname,
        id: this.state.weekoffpolicyid ? this.state.weekoffpolicyid : null,
      };
      instance
        .post(URL, data)
        .then((result) => {
          if (result.data.result[0].isunique == true) {
            this.setState({ notUnique: false, ErName: false }, () => {
              this.props.StepError(1, false);
              this.UpdateweekoffPlannerReducer();
              if (goNext === true) this.props.click();
            });
          } else if (result.data.result[0].isunique == false) {
            this.setState({ notUnique: true, ErName: false }, () => {
              this.props.StepError(1, true);
            });
          }
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.setState({ notUnique: true, ErName: false, CommonError });
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      this.setState({ notUnique: false, ErName: true }, () => {
        this.props.StepError(1, true);
      });
    }
  }

  Validate() {
    let isValid = true;
    let ErName = false;
    if (!this.state.weekoffpolicyname) {
      ErName = true;
      this.setState({ ErName });
      return (isValid = false);
    }

    this.setState({ ErName });
    return isValid;
  }

  UpdateweekoffPlannerReducer() {
    const weekoffPlannerInfo = this.props.weekoffPlannerReducer;
    // weekoffPlannerInfo.shiftcategoryid = weekoffPlannerInfo.shiftcategoryid
    //   ? weekoffPlannerInfo.shiftcategoryid
    //   : null;
    weekoffPlannerInfo.weekoffpolicyid = weekoffPlannerInfo.weekoffpolicyid
      ? weekoffPlannerInfo.weekoffpolicyid
      : null;
    weekoffPlannerInfo.parentid = weekoffPlannerInfo.parentid
      ? weekoffPlannerInfo.parentid
      : 0;
    // weekoffPlannerInfo.isdraft = this.state.isdraft ? weekoffPlannerInfo.isdraft : true
    weekoffPlannerInfo.totalweekoffdays = weekoffPlannerInfo.totalweekoffdays
      ? weekoffPlannerInfo.totalweekoffdays
      : 0;
    weekoffPlannerInfo.canmanagerupdate = weekoffPlannerInfo.canmanagerupdate
      ? weekoffPlannerInfo.canmanagerupdate
      : true;
    weekoffPlannerInfo.isemployeeapproval = weekoffPlannerInfo.isemployeeapproval
      ? weekoffPlannerInfo.isemployeeapproval
      : true;
    weekoffPlannerInfo.canemployeeupdate = weekoffPlannerInfo.canemployeeupdate
      ? weekoffPlannerInfo.canemployeeupdate
      : true;
    weekoffPlannerInfo.ismanagerapproval = weekoffPlannerInfo.ismanagerapproval
      ? weekoffPlannerInfo.ismanagerapproval
      : true;
    weekoffPlannerInfo.isaccumulation = weekoffPlannerInfo.isaccumulation
      ? weekoffPlannerInfo.isaccumulation
      : false;
    weekoffPlannerInfo.accumulationtypeid = weekoffPlannerInfo.accumulationtypeid
      ? weekoffPlannerInfo.accumulationtypeid
      : null;
    weekoffPlannerInfo.refreshtypeid = weekoffPlannerInfo.refreshtypeid
      ? weekoffPlannerInfo.refreshtypeid
      : null;
    weekoffPlannerInfo.accumulationlimit = weekoffPlannerInfo.accumulationlimit
      ? weekoffPlannerInfo.accumulationlimit
      : null;
    weekoffPlannerInfo.weekoffdetail = weekoffPlannerInfo.weekoffdetail
      ? weekoffPlannerInfo.weekoffdetail
      : [
          {
            weekoffdetailid: null,
            weekdayid: 0,
            fullweekoffids: null,
            halfweekoffids: null,
            islasthalfweekoff: false,
            islastfullweekoff: false,
          },
        ];
    weekoffPlannerInfo.weekoffpolicyname = this.state.weekoffpolicyname;
    weekoffPlannerInfo.description = this.state.description;
    this.props.WeekoffPlanner({ ...weekoffPlannerInfo });
  }

  OnNext = () => {
    if (this.state.weekoffpolicyname && !isSpaceInString(this.state.weekoffpolicyname)) {
      this.state.weekoffpolicyname = this.state.weekoffpolicyname.trim();
    } 
     if (!this.state.weekoffpolicyname) {
      this.setState({ notUnique: false, ErName: true });
      this.props.StepError(1, true);
    } else {
      this.props.StepError(1, false);
      this.UpdateweekoffPlannerReducer();
      this.props.click();
    }
  };

  OnCancel() {
    this.props.Cancel(true);
  }

  HelperSliderFlag(HtField) {
    const text = get(this.props, `Language.weekoff[${HtField}]`);
    // let text = this.props.Language.weekoff[HtField]
    this.props.setHelperText({ helperText: text, open: true });
  }

  render() {
    return (
      <Grid container>
        <div className="stepper-scroller padding-top-0">
          <div className="stepper-scroller-content">
            <Grid item xs={12} md={12} sm={12}>
              <div className="device-wrapper shift-planner-form">
                <p className="form-input-label">
                  <FormattedMessage
                    id="HtWeeklyoffName"
                    defaultMessage="Weekly-off Name"
                  />
                </p>
                {/* <input type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    autoFocus placeholder="Weekly-off Name"
                                    onChange={this.OnNameChange.bind(this)}
                                    value={this.state.weekoffpolicyname}
                                    onBlur={this.checkUnique.bind(this)}
                                    onFocus={this.HelperSliderFlag.bind(this, "HtWeeklyoffName")}
                                    maxLength="50" /> */}
                <TextField
                  id="outlined-dense"
                  margin="dense"
                  variant="outlined"
                  autoComplete="off"
                  style={{ width: "100%" }}
                  placeholder="Enter Weekly-off Name"
                  onChange={this.OnNameChange.bind(this)}
                  value={this.state.weekoffpolicyname}
                  onBlur={this.checkUnique.bind(this)}
                  onFocus={this.HelperSliderFlag.bind(this, "HtWeeklyoffName")}
                  maxLength="100"
                  className="form-text-input"
                  autoFocus
                />
                <div>
                  {this.state.ErName == true ? (
                    <span className="caption-error">
                      <FormattedMessage
                        id="ErName"
                        defaultMessage="Weekly-off Name can not be empty"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                  {this.state.notUnique == true ? (
                    <span className="caption-error">
                      {this.state.CommonError}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="device-wrapper shift-planner-form">
                <p className="form-input-label">
                  <FormattedMessage
                    id="HtInternalDescription"
                    defaultMessage="Let’s write a brief description about this Weekly-off"
                  />
                </p>
                {/* <textarea
                  className="input-area-section"
                  placeholder="Description "
                  onChange={this.OnDescriptionChange.bind(this)}
                  value={this.state.description}
                  maxLength="200"
                  onFocus={this.HelperSliderFlag.bind(this, "HtInternalDescription")}
                /> */}
                <TextArea
                  className="width100"
                  maxLength="200"
                  variant="outlined"
                  placeholder="Description "
                  multiline
                  onChange={this.OnDescriptionChange.bind(this)}
                  value={this.state.description}
                  onFocus={this.HelperSliderFlag.bind(
                    this,
                    "HtInternalDescription",
                  )}
                />
              </div>
            </Grid>
          </div>
        </div>
      </Grid>
    );
  }
}

WeeklyNameAndDescription.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  weekoffPlannerReducer: state.weekoffPlannerReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      setHelperText: (data) => setHelperText(data),
      WeekoffPlanner: (data) => WeekoffPlanner(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(WeeklyNameAndDescription)));
